var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ADD_TO_CART_ERROR, ADD_TO_CART_REQUEST, ADD_TO_CART_SUCCESS, CANCEL_SIGN_EDITING, CANVAS_TYPE_CHANGED, CART_IMAGES, DECAL_EDITOR_SETTINGS_LOAD_ERROR, DECAL_EDITOR_SETTINGS_RECEIVE, LOAD_EDITOR_TEMPLATE_SUCCESS, LOAD_SIGN_FOR_EDIT_ERROR, LOAD_SIGN_FOR_EDIT_REQUEST, LOAD_SIGN_FOR_EDIT_SUCCESS, LOCK_CANVAS_EDITING, RESET_CANVAS, } from '../../Rutab/RutabConstants';
import { load } from '../../Actions/Rutab/RutabCart.action';
import { get, post, put, uploadFile } from '../../Services/http';
import { catchError } from '../Error.action';
import { CART_RECEIVE, CART_SHOW_INFO } from '../../constants';
import { handleUrlUpdate } from '../../Helpers/UrlService';
export const loadDecalEditorSettings = () => (dispatch, getState) => {
    return get('/api/decal/settings')
        .then((response) => response.json())
        .then((settings) => {
        dispatch(receiveDecalEditorSettings(settings));
        dispatch({
            type: CANVAS_TYPE_CHANGED,
            payload: { canvasType: settings.decalProductsSettings[0] },
        });
    })
        .catch((ex) => dispatch(catchError(ex, (error) => loadDecalEditorSettingsError(error))));
};
export const loadDecalEditorSettingsError = (error) => ({
    type: DECAL_EDITOR_SETTINGS_LOAD_ERROR,
    payload: {
        error,
    },
});
export const receiveDecalEditorSettings = (settings) => ({
    type: DECAL_EDITOR_SETTINGS_RECEIVE,
    payload: {
        settings,
    },
});
export const receive = (cart) => ({
    type: CART_RECEIVE,
    payload: cart,
});
export const addToCart = (requestModel, quantity) => (dispatch, getState) => {
    dispatch({ type: ADD_TO_CART_REQUEST });
    return post(`/api/decal/cart/add?quantity=${quantity}`, requestModel)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        dispatch(addToCartSuccess(result));
        dispatch(resetCanvasToDefaults());
        dispatch(load());
        // Dispatch a custom event to trigger the cart animation
        const cartAddedEvent = new CustomEvent('cartItemAdded', {
            detail: { quantity: quantity },
        });
        window.dispatchEvent(cartAddedEvent);
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(addToCartError(result));
        });
    });
};
export const updateCartItem = (requestModel, quantity) => (dispatch, getState) => {
    dispatch({ type: ADD_TO_CART_REQUEST });
    return put(`/api/decal/cart/update?quantity=${quantity}`, requestModel)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        dispatch(addToCartSuccess(result));
        dispatch(resetCanvasToDefaults(false));
        dispatch(load());
        // Dispatch a custom event to trigger the cart animation
        const cartAddedEvent = new CustomEvent('cartItemAdded', {
            detail: { quantity: quantity },
        });
        window.dispatchEvent(cartAddedEvent);
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(addToCartError(result));
        });
    });
};
export const removeCartItem = (rowSystemId, resetCanvas = false) => (dispatch, getState) => {
    return put(`/api/decal/cart/delete/${rowSystemId}?resetCanvas=${resetCanvas}`)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        if (resetCanvas) {
            dispatch(resetCanvasToDefaults(true));
            handleUrlUpdate();
        }
        dispatch(load());
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(addToCartError(result));
        });
    });
};
export const addToCartSuccess = (result) => ({
    type: ADD_TO_CART_SUCCESS,
    payload: {
        result,
    },
});
export const addToCartError = (error) => ({
    type: ADD_TO_CART_ERROR,
    payload: {
        error,
    },
});
export const resetCanvas = () => ({
    type: RESET_CANVAS,
});
export const resetCanvasToDefaults = (resetEditingSign = true, loadSign = false) => (dispatch, getState) => {
    var _a;
    const state = getState();
    const canvasType = (_a = state.decalEditorAPI.settings) === null || _a === void 0 ? void 0 : _a.decalProductsSettings[0];
    const editingSign = state.decalEditorAPI.signForEdit;
    const productTemplate = state.decalEditorAPI.productTemplate;
    dispatch({
        type: RESET_CANVAS,
        payload: {
            defaultCanvasType: canvasType,
        },
    });
    requestAnimationFrame(() => {
        if (editingSign && resetEditingSign) {
            dispatch({ type: CANCEL_SIGN_EDITING });
            dispatch({
                type: CART_SHOW_INFO,
                payload: {
                    showInfo: false,
                },
            });
        }
        if (productTemplate) {
            dispatch(loadEditorTemplateSuccess(null));
        }
        if (loadSign && editingSign) {
            dispatch(loadSignForEdit(editingSign.rowSystemId));
        }
    });
};
export const loadSignForEdit = (id) => (dispatch, getState) => {
    dispatch({
        type: LOAD_SIGN_FOR_EDIT_REQUEST,
        payload: {
            isLoading: true,
        },
    });
    return get(`/api/decal/cart/get-for-edit/${id}`)
        .then((response) => response.json())
        .then((sign) => {
        if (sign.productTemplateId) {
            dispatch(loadEditorTemplate(sign.productTemplateId));
        }
        dispatch(loadSignForEditSuccess(sign));
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            dispatch(loadSignForEditError(result));
        });
    });
};
export const loadSignForEditSuccess = (sign) => ({
    type: LOAD_SIGN_FOR_EDIT_SUCCESS,
    payload: {
        sign,
    },
});
export const loadSignForEditError = (error) => ({
    type: LOAD_SIGN_FOR_EDIT_ERROR,
    payload: {
        error,
    },
});
export const uploadImage = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const formData = new FormData();
    formData.append('image', file);
    return uploadFile('/api/decal/upload-image', formData)
        .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
        .then((result) => {
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
});
export const loadCartImages = () => (dispatch, getState) => {
    return get('/api/decal/cart-images')
        .then((response) => response.json())
        .then((images) => {
        dispatch({
            type: CART_IMAGES,
            payload: {
                images,
            },
        });
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
};
export const calculatePrice = (priceRequest) => __awaiter(void 0, void 0, void 0, function* () {
    return post(`/api/decal/price`, priceRequest)
        .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
        .then((result) => {
        return result;
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
});
export const saveTemplate = (saveEditorTemplateData) => (dispatch, getState) => {
    return post('/api/decal/templates/save', saveEditorTemplateData)
        .then((response) => {
        response === null || response === void 0 ? void 0 : response.json();
    })
        .then((result) => {
        dispatch(resetCanvasToDefaults(true));
        return result;
    })
        .catch((ex) => {
        console.error('Error saving template:', ex);
        throw ex;
    });
};
export const loadEditorTemplates = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield get('/api/decal/templates');
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return yield response.json();
    }
    catch (ex) {
        console.error('Error loading templates:', ex);
        throw ex;
    }
});
export const loadEditorTemplate = (id) => (dispatch, getState) => {
    dispatch({
        type: LOAD_SIGN_FOR_EDIT_REQUEST,
        payload: {
            isLoading: true,
        },
    });
    return get(`/api/decal/templates/${id}`)
        .then((response) => response.json())
        .then((template) => {
        requestAnimationFrame(() => {
            dispatch(loadEditorTemplateSuccess(template));
            dispatch({
                type: LOCK_CANVAS_EDITING,
            });
        });
    })
        .catch((ex) => {
        ex.response.json().then((result) => {
            console.log(result);
        });
    });
};
export const loadEditorTemplateSuccess = (template) => ({
    type: LOAD_EDITOR_TEMPLATE_SUCCESS,
    payload: {
        template,
    },
});
